import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from './store/index'

//ele-系列组件
import {
  Pagination,
  Container,
  Header,
  Aside,
  Main,
  Tabs,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Tag,
  Input,
  InputNumber,

  Dialog,
  Scrollbar,
  Icon,
  Checkbox,
  Radio,
  RadioGroup,
  RadioButton,
  Option,
  Button,
  Select,
  Table,
  TableColumn,
  DatePicker,
  Loading,
  Popover,
  Tooltip,
  MessageBox,
  Alert,
  Message,
  Notification,
  Carousel,
  CarouselItem,
  Form,
  Rate,
  FormItem, Upload,
  //Avatar
} from 'element-ui'
Vue.use(Pagination)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(Input)
Vue.use(InputNumber)

Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Alert)
Vue.use(Scrollbar)
Vue.use(Carousel)
Vue.use(CarouselItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Upload);
Vue.use(Rate);
//Vue.use(Avatar);


Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

import '@/assets/css/common.css'

Vue.config.productionTip = false
Vue.config.devtools = true

import VueWeChatTitle from 'vue-wechat-title'
Vue.use(VueWeChatTitle)
// cookie
import cookie from '@/util/cookie.js'
Vue.use(cookie)

//加载插件
import Loader from '@/components/Loader.vue'
let JYloader = {
  install: null
};

JYloader.install = function (Vue, options) {
  var LoaderComponent;
  Vue.prototype.$loader = function (options) {

    if (typeof options == undefined) {
      options = {
        showLoader: true,
        showIcon: true,
        iconType: 1,
        loaderStyle: 'dark',
        duration: 1000,
        tips: '加载中...'
      }
    } else {
      options.showLoader = true;
    }

    var Newloader = Vue.extend(Loader);
    LoaderComponent = new Newloader({
      data: options
    }).$mount()

    document.querySelector('body').appendChild(LoaderComponent.$el);
    return LoaderComponent;
  }

  Vue.prototype.$loader.hide = function () {
    LoaderComponent.showLoader = false;
  }

}

Vue.use(JYloader);

Vue.prototype.$store = store;

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js